/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/arrow.png';
import _imports_1 from '@/assets/img/arrow_2.png';
var _hoisted_1 = {
  class: "device-info-collapse-list"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "van-collapse-item-status-ing van-collapse-item-status"
};
var _hoisted_5 = {
  class: "van-collapse-item-status-expect van-collapse-item-status"
};
var _hoisted_6 = {
  class: "van-collapse-item-status-cancel van-collapse-item-status"
};
var _hoisted_7 = {
  class: "collapse-item-title-text"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "van-collapse-content"
};
var _hoisted_10 = {
  class: "content-item"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备型号", -1);
var _hoisted_12 = {
  class: "content-item-value"
};
var _hoisted_13 = {
  class: "content-item"
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备编号", -1);
var _hoisted_15 = {
  class: "content-item-value"
};
var _hoisted_16 = {
  class: "content-item"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备类型", -1);
var _hoisted_18 = {
  class: "content-item-value"
};
var _hoisted_19 = {
  class: "content-item"
};
var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "厂家名称", -1);
var _hoisted_21 = {
  class: "content-item-value"
};
var _hoisted_22 = {
  key: 0,
  class: "van-collapse-footer"
};
import './collapseLite.less';
// eslint-disable-next-line no-undef
export default /*#__PURE__*/_defineComponent({
  __name: 'CollapseList',
  props: {
    listData: {
      default: function _default() {
        return [];
      }
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var listData = props.listData,
      footer = props.footer;
    var router = useRouter();
    var activeNames = ref('');
    var goToDetail = function goToDetail(deviceNum, factoryId) {
      router.push({
        path: '/deviceInfo/detail',
        query: {
          device_num: deviceNum,
          factoryId: factoryId
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_van_collapse_item = _resolveComponent("van-collapse-item");
      var _component_van_collapse = _resolveComponent("van-collapse");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_collapse, {
        modelValue: _unref(activeNames),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(activeNames) ? activeNames.value = $event : null;
        }),
        accordion: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), function (item, index) {
            return _openBlock(), _createBlock(_component_van_collapse_item, {
              key: index,
              name: item.id
            }, {
              "right-icon": _withCtx(function () {
                return [_hoisted_2];
              }),
              title: _withCtx(function () {
                return [_createElementVNode("div", {
                  class: "van-collapse-item-title",
                  onClick: _withModifiers(function () {
                    return goToDetail(item.deviceNum, item.factoryId);
                  }, ["stop"])
                }, [_withDirectives(_createElementVNode("div", _hoisted_4, " 启用 ", 512), [[_vShow, item.status === 0]]), _withDirectives(_createElementVNode("div", _hoisted_5, " 停用 ", 512), [[_vShow, item.status === 1]]), _withDirectives(_createElementVNode("div", _hoisted_6, " 报废 ", 512), [[_vShow, item.status === 2]]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.deviceName), 1)], 8, _hoisted_3)];
              }),
              default: _withCtx(function () {
                return [_createElementVNode("div", {
                  class: "van-collapse",
                  onClick: _withModifiers(function () {
                    return goToDetail(item.deviceNum, item.factoryId);
                  }, ["stop"])
                }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(item.deviceModel || '--'), 1)]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString(item.deviceNum || '--'), 1)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString(item.dictLabel || '--'), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(item.eaManufacturersInfo.manufacturerName || '--'), 1)])]), _unref(footer) ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_renderSlot(_ctx.$slots, "footer", {
                  item: item
                })])) : _createCommentVNode("", true)], 8, _hoisted_8)];
              }),
              _: 2
            }, 1032, ["name"]);
          }), 128))];
        }),
        _: 3
      }, 8, ["modelValue"])]);
    };
  }
});